/**
 * @generated SignedSource<<9c9626adcb352e7380ade7f06f44b746>>
 * @relayHash ae101ad519f93d6ee8fda249fac0cfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentCreationLocation = "DATABASE" | "EDITOR" | "LIVE" | "RENDERER" | "SLIDE" | "WHITEBOARD" | "%future added value";
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ReplyInlineCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null | undefined;
  containerId: string;
  createdFrom?: CommentCreationLocation | null | undefined;
  parentCommentId: string;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type InlineCommentCreateInlineReplyMutation$variables = {
  includeReactions: boolean;
  input: ReplyInlineCommentInput;
  pageId: string;
};
export type InlineCommentCreateInlineReplyMutation$data = {
  readonly replyInlineComment: {
    readonly author: {
      readonly accountId?: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly permissionType: SitePermissionType | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null | undefined;
      readonly webui: string | null | undefined;
    };
    readonly location: {
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineMarkerRef?: string | null | undefined;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null | undefined;
        readonly resolvedTime: AGG$Long | null | undefined;
        readonly resolvedUser: string | null | undefined;
      } | null | undefined;
      readonly inlineText?: string | null | undefined;
      readonly type: string;
    };
    readonly parentId: string | null | undefined;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null | undefined>;
    } | null | undefined;
    readonly version: {
      readonly by: {
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly number: number | null | undefined;
      readonly when: string | null | undefined;
    };
  } | null | undefined;
};
export type InlineCommentCreateInlineReplyMutation = {
  response: InlineCommentCreateInlineReplyMutation$data;
  variables: InlineCommentCreateInlineReplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v6 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v7 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v8 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v5/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v10 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v14 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v18 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v19 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v21 = {
  "kind": "ScalarField",
  "name": "when"
},
v22 = {
  "kind": "ScalarField",
  "name": "number"
},
v23 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v26 = {
  "condition": "includeReactions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "pageId"
        }
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            }
          ]
        }
      ]
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "InlineCommentCreateInlineReplyMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replyInlineComment",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          },
          (v26/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InlineCommentCreateInlineReplyMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replyInlineComment",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v11/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          },
          (v26/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ae101ad519f93d6ee8fda249fac0cfef",
    "id": "5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566",
    "metadata": {},
    "name": "InlineCommentCreateInlineReplyMutation",
    "operationKind": "mutation",
    "text": "mutation InlineCommentCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
  }
};
})();

(node as any).hash = "1a07d4cb81840d6ebad5fbdcb4c879da";

export default node;
